<template>
  <div class="user_list_page">

    <business-group :tableConfig="{ ...tableConfig }" :formConfig="{ ...formConfig }" ref="businessGroup">
      <!-- 查询 -->
      <template #formSlot>
        <a-form-item>
          <a-input placeholder="请输入场景特效中文名称" v-decorator="['chinese']" style="width: 200px; margin-right: 10px; vertical-align: middle" />
        </a-form-item>
      </template>

      <!-- 添加 -->
      <template #formRight>
        <a-space>
          <a-button v-show="true" type="primary" @click="importModal">导入</a-button>
          <a-button type="primary" @click="addModal">新增</a-button>
        </a-space>
      </template>

      <!-- 创建时间格式化 -->
      <template #createTime="record">
        {{ dataFormatStr(record.createTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>

      <!-- 修改时间格式化 -->
      <template #updateTime="record">
        {{ dataFormatStr(record.updateTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>

      <!-- 操作 -->
      <template #action="record">
        <a-button type="link" @click="() => updateModal(record)">修改</a-button>
        <a-button type="link" @click="() => deleted(record)">删除</a-button>
      </template>

    </business-group>

    <!--  导入弹窗  -->
    <a-modal title="导入" destroyOnClose :visible="importVisible" :maskClosable="false" @ok="handleImport" @cancel="() => importVisible = false" :confirmLoading="importLoading">

      <a-upload-dragger name="file" v-model:fileList="fileList" :beforeUpload="beforeUpload" :multiple="false" accept=".xlsx,.xls">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
        <p class="ant-upload-hint">支持单次上传，支持 .xlsx 和 .xls 格式</p>
      </a-upload-dragger>
      <div class="download-template" style="margin-top: 20px;">
        <span>没有模板？</span>
        <a href="#" @click.prevent="downloadTemplate">点击下载模板</a>
      </div>

    </a-modal>

    <!--  添加弹窗  -->
    <a-modal title="新增" destroyOnClose :visible="addVisible" :maskClosable="false" @ok="add" @cancel="() => addVisible = false">
      <a-form-model :modal="addFrom" layout="vertical" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="中文:">
          <a-input placeholder="中文" v-model.trim="addFrom.chinese" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="English:">
          <a-input placeholder="English" v-model.trim="addFrom.english" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Français:">
          <a-input placeholder="Français" v-model.trim="addFrom.french" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Nederlands:">
          <a-input placeholder="Nederlands" v-model.trim="addFrom.dutch" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Español:">
          <a-input placeholder="Español" v-model.trim="addFrom.spanish" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Italiano:">
          <a-input placeholder="Italiano" v-model.trim="addFrom.italian" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="日本語:">
          <a-input placeholder="日本語" v-model.trim="addFrom.japanese" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Deutsch:">
          <a-input placeholder="Deutsch" v-model.trim="addFrom.deutsch" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--  修改弹窗  -->
    <a-modal title="修改" destroyOnClose :visible="updateVisible" :maskClosable="false" @ok="update" @cancel="() => updateVisible = false">
      <a-form-model :modal="updateFrom" layout="vertical" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="id:" v-show="false">
          <a-input placeholder="id" v-model="updateFrom.id" showCount :max-length="64" />
        </a-form-model-item>
        <a-form-model-item label="中文:">
          <a-input placeholder="中文" v-model.trim="updateFrom.chinese" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="English:">
          <a-input placeholder="English" v-model.trim="updateFrom.english" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Français:">
          <a-input placeholder="Français" v-model.trim="updateFrom.french" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Nederlands:">
          <a-input placeholder="Nederlands" v-model.trim="updateFrom.dutch" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Español:">
          <a-input placeholder="Español" v-model.trim="updateFrom.spanish" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Italiano:">
          <a-input placeholder="Italiano" v-model.trim="updateFrom.italian" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="日本語:">
          <a-input placeholder="日本語" v-model.trim="updateFrom.japanese" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
        <a-form-model-item label="Deutsch:">
          <a-input placeholder="Deutsch" v-model.trim="updateFrom.deutsch" showCount :max-length="64" style="float: none" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import { tips } from "@/utils/util";
import { formatToStr } from "@/utils/dateUtils";
import service, { post } from "@/utils/request";

export default {
  components: {
    pageTitle,
    businessGroup
  },
  data() {
    return {
      tableConfig: {
        url: "bluetoothlight/web/router/neewerhome/manage/device/eightLang/pages",
        rowKey: "id",
        columns: [
          {
            title: "主键ID",
            dataIndex: "id",
            key: "id",
            align: "left"
          },
          {
            title: "中文",
            dataIndex: "chinese",
            key: "chinese",
            align: "left",
            ellipsis: true
          },
          {
            title: "English",
            dataIndex: "english",
            key: "english",
            align: "left",
            ellipsis: true
          },
          {
            title: "Français",
            dataIndex: "french",
            key: "french",
            align: "left",
            ellipsis: true
          },
          {
            title: "Nederlands",
            dataIndex: "dutch",
            key: "dutch",
            align: "left",
            ellipsis: true
          },
          {
            title: "Español",
            dataIndex: "spanish",
            key: "spanish",
            align: "left",
            ellipsis: true
          },
          {
            title: "Italiano",
            dataIndex: "italian",
            key: "italian",
            align: "left",
            ellipsis: true
          },
          {
            title: "日本語",
            dataIndex: "japanese",
            key: "japanese",
            align: "left",
            ellipsis: true
          },
          {
            title: "Deutsch",
            dataIndex: "deutsch",
            key: "deutsch",
            align: "left",
            ellipsis: true
          },
          {
            title: "创建时间",
            key: "createTime",
            scopedSlots: { customRender: "createTime" },
            align: "left"
          },
          {
            title: "修改时间",
            key: "updateTime",
            scopedSlots: { customRender: "updateTime" },
            align: "left"
          },
          {
            title: "操作",
            align: "center",
            width: 150,
            fixed: "right",
            scopedSlots: { customRender: "action" }
          }
        ]
      },
      formConfig: {
        timeShow: false,
        formShow: true
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 30 },
      importVisible: false,
      importLoading: false,
      addVisible: false,
      updateVisible: false,
      fileList: [],
      // 新增表单
      addFrom: {
        chinese: "",
        english: "",
        french: "",
        dutch: "",
        spanish: "",
        italian: "",
        japanese: "",
        deutsch: ""
      },
      // 修改表单
      updateFrom: {
        id: null,
        chinese: "",
        english: "",
        french: "",
        dutch: "",
        spanish: "",
        italian: "",
        japanese: "",
        deutsch: ""
      }
    };
  },
  methods: {
    // 时间格式化
    dataFormatStr(ret, format) {
      if (!ret) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD HH:mm:ss";
      }
      return formatToStr(ret, format);
    },

    // 导入弹窗
    importModal: function() {
      this.importVisible = true;
    },

    // 文件上传前的验证
    beforeUpload(file) {
      const isExcel = file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        tips(this, false, "只能上传 Excel 文件!");
        return false;
      }
      this.fileList.push(file);
      return false;
    },

    // 处理确认按钮
    handleImport: async function() {
      if (this.fileList.length === 0) {
        tips(this, false, "请选择要上传的Excel文件");
        return;
      }
      this.importLoading = true;
      try {
        let url = "bluetoothlight/web/router/multipart/neewerhome/manage/device/eightLang/import";
        const formData = new window.FormData();
        formData.append("file", this.fileList[0]);
        const result = await this.$post(url, formData);
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.importVisible = false;
        }
      } catch (error) {
        tips(this, false, "上传失败：" + error.message);
      } finally {
        this.importLoading = false;
      }
    },

    // 下载模板
    downloadTemplate() {
      const link = document.createElement("a");
      link.href = "https://usdb.oss-us-west-1.aliyuncs.com/neewerhome/sceneEffect/%E5%9C%BA%E6%99%AF%E7%89%B9%E6%95%88%E5%90%8D%E7%A7%B0%E7%BF%BB%E8%AF%91%E6%96%87%E6%A1%A3%E6%A8%A1%E6%9D%BF.xlsx?x-oss-credential=LTAI5tDe5Kq76tctypmvg8i8%2F20260116%2Fus-west-1%2Foss%2Faliyun_v4_request&x-oss-date=20260116T022710Z&x-oss-expires=3600&x-oss-signature-version=OSS4-HMAC-SHA256&x-oss-signature=f687320abab58e541a6db3b1327292f3542bd4e613054f6c36f54dbb46b4f4ef";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 新增弹窗
    addModal: function() {
      this.addFrom = {
        chinese: "",
        english: "",
        french: "",
        dutch: "",
        spanish: "",
        italian: "",
        japanese: "",
        deutsch: ""
      };
      this.addVisible = true;
    },

    // 新增
    add: async function() {
      let url = "bluetoothlight/web/router/neewerhome/manage/device/eightLang/add";
      try {
        const result = await this.$post(url, this.addFrom);
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.addVisible = false;
        }
      } catch (error) {
        console.error("新增时发生错误:", error);
        tips(this, false, "新增时发生错误");
      }
    },

    // 修改弹窗
    updateModal: function(record) {
      this.updateFrom = record;
      this.updateVisible = true;
    },

    // 修改
    update: async function() {
      let url = "bluetoothlight/web/router/neewerhome/manage/device/eightLang/update";
      try {
        const result = await this.$post(url, this.updateFrom);
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.updateVisible = false;
        }
      } catch (error) {
        console.error("修改时发生错误:", error);
        tips(this, false, "修改时发生错误");
      }
    },

    // 删除
    deleted: async function(record) {
      let url = "bluetoothlight/web/router/neewerhome/manage/device/eightLang/delete";
      try {
        const result = await this.$get(url, { "id": record.id });
        const resultStatus = result?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.updateVisible = false;
        }
      } catch (error) {
        console.error("删除时发生错误:", error);
        tips(this, false, "删除时发生错误");
      }
    },

    // 刷新
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    }
  }
};
</script>


<style lang="less" scoped>
.avatar-uploader > .ant-upload {
  width: 300px;
  height: 128px;
}

.user_list_page {
  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
}
</style>
  